import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Nav = styled.div`
  width: 90px;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-right: 3px solid #51c0dc;
  border-left: 3px solid #51c0dc;
  box-shadow: 5px 10px 50px #51c0dc;
`;

export const ContainerImg = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;
`;

export const Logo = styled.img`
  width: 100px;
  height: 100px;
`;

export const ContainerH1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
`;

export const H1 = styled.h1`
  font-size: 18px;
  color: white;
  margin-top: -20px;
`;

export const P = styled.p`
  font-weight: bold;
  margin-top: -5px;
  color: transparent;
  background-image: linear-gradient(
    to left,
    #ffd700,
    #7b68ee,
    #3498db,
    #2ecc71,
    #ffd700
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: color 3s linear infinite;
  background-size: 500%;

  @keyframes color {
    from {
      background-position: 0% 50%;
    }
    to {
      background-position: 100% 50%;
    }
  }
`;

export const ContainerLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  //border-top: 1px solid #51c0dc;
  //border-bottom: 1px solid #51c0dc;
`;

export const Link = styled(NavLink)`
  font-weight: bold;
  border-radius: 15px;
  padding-top: 20px;
  text-decoration: none;
  text-align: center;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 10px;
  box-shadow: inset 0 0 0 0 black;
  transition: color 0.3s ease-in-out, box-shadow 0.5s ease-in-out;
  color: white;
  width: 85px;
  padding-bottom: 20px;
  &:hover {
    color: black;
    box-shadow: inset 100px 5px 100px 20px #51c0dc;
  }
  &.active {
    color: black;
    background-color: #51c0dc;
  }
`;

export const ContainerSocialNetworks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
`;

export const A = styled.a`
  margin-top: 40px;
  &:hover {
    transition: 800ms;
    transform: scale(1.2);
  }
`;

export const ImgSN = styled.img`
  width: 60px;
  height: 60px;
`;

export const LinkLogo = styled(NavLink)`
  margin: 0px;
`;
